import { Stack } from "@certa/catalyst/layouts/Stack";
import { Ellipsis } from "@certa/catalyst/components/Typography";

import { sanitizeHTML } from "@certa/common/utils/sanitizeHTML";

import styles from "./DataObjectFields.module.css";

type DataObjectUrlFieldProps = {
  url: string;
};

export const DataObjectUrlField = (props: DataObjectUrlFieldProps) => {
  const { url } = props;

  return (
    <Stack direction="horizontal" align="center">
      <a
        href={sanitizeHTML(url)}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.dataObjectUrlField}
      >
        <Ellipsis>{url}</Ellipsis>
      </a>
    </Stack>
  );
};
